import eventManger from '../utilities/EventManager';
import _ from 'lodash';

export const FIELD_TREE_PARTNER_BOX = {
  REFRESH_LIST: _.uniqueId('ft_partner_box_refresh'), //協力会社一覧をリフレッシュ
  SEARCH_FORM_OPEN: _.uniqueId('ft_search_form_open'), // 検索項目の開閉イベント
  SEARCH_CLEAR: _.uniqueId('ft_search_clear'), // 検索条件クリアイベント
  SERACH_PARAM_UPDATE: _.uniqueId('ft_search_param_update'), // 検索パラメータ更新
  UPDATE_FORM: _.uniqueId('ft_update_form_value'), // 編集内容を保存
  DELETE_USER: _.uniqueId('ft_delete_uuser'), // ユーザーを削除
  DROPDOWN_VALUE: _.uniqueId('ft_dropdown_value'), //ドロップダウン
  COMPANY_DELETE: _.uniqueId('ft_company_delete'), //協力会社削除

  //ヘッダーメニュー
  DRAG_ITEM: _.uniqueId('ft_drag_item'), //ドラッグアイテム
  SAVE_ORDER: _.uniqueId('ft_save_order'), //並び順を保存
  ORDER_UPDATE: _.uniqueId('ft_order_update'), //並び順更新
  NEW_FORM: _.uniqueId('ft_new_form'), //新規登録フォーム
  EDIT_FORM: _.uniqueId('ft_edit_form'), //編集フォーム
  EDIT_DONE: _.uniqueId('ft_edit_done'), //作業を終了
  EDIT_STATUS: _.uniqueId('ft_edit_status'), //ステータス変更
  SEARCH_AND_ADD: _.uniqueId('ft_search_adn_add'), //検索して追加
  EXPORT_CSV: _.uniqueId('ft_export_csv'), //CSVを出力
  FINISH_CANCEL: _.uniqueId('ft_approval_finish_cancel'), //作業終了を取り消す
  APPROVAL_DONE: _.uniqueId('ft_approval_done'), //承認依頼
  APPROVAL_REJECTED: _.uniqueId('ft_approval_rejected'), //否認
  APPROVAL_OFFER: _.uniqueId('ft_approval_offer'), //承認依頼
  APPROVAL_CANCEL: _.uniqueId('ft_approval_cancel'), //承認依頼取り消し
  NEW_PRE_DIALOG: _.uniqueId('ft_new_pre_dialog'), //新規作成誤登録防止ダイアログ
  NEW_DIALOG: _.uniqueId('ft_new_dialog'), //新規登録ダイアログ
  INVITE_USER_DIALOG: _.uniqueId('ft_invite_user_dialog'), //管理者招待ダイアログ
};

class Events {
  constructor() {
    for (let key in FIELD_TREE_PARTNER_BOX) {
      eventManger.registerEvent(FIELD_TREE_PARTNER_BOX[key]);
    }
  }

  removeAll() {
    for (let key in FIELD_TREE_PARTNER_BOX) {
      eventManger.deleteEvent(FIELD_TREE_PARTNER_BOX[key]);
    }
  }
}

const FieldTreePartnerBoxEvents = new Events();
export default FieldTreePartnerBoxEvents;



// WEBPACK FOOTER //
// ./src/components/FieldTreePartnerBoxEvents.js